import {printoutPalette} from "../../core/printoutPalette";

export const qrCodeBlockSx = {
    width: "100%",
    // QR codes must stay intact across native print pagination.
    "@media print": {
        breakInside: "avoid",
        pageBreakInside: "avoid",
    },
    "& .printout-qr-code-frame": {
        boxSizing: "border-box",
        display: "flex",
        flexShrink: 0,
        maxWidth: "100%",
        // Browsers must preserve QR ink during printing.
        printColorAdjust: "exact",
        WebkitPrintColorAdjust: "exact",
    },
    "& .printout-qr-code-frame > svg": {
        display: "block",
        height: "100%",
        width: "100%",
    },
    "& .printout-qr-code-frame-empty": {
        alignItems: "center",
        border: `1px dashed ${printoutPalette.border}`,
        borderRadius: "4px",
        justifyContent: "center",
        overflow: "hidden",
    },
    "& .printout-qr-code-placeholder": {
        alignItems: "center",
        color: printoutPalette.mutedText,
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        overflow: "hidden",
        textAlign: "center",
        width: "100%",
    },
    "& .printout-qr-code-placeholder-hint": {
        fontSize: "10px",
        lineHeight: 1.2,
    },
};
